import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { drawerAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(drawerAnatomy.keys);

const baseStyle = definePartsStyle({
  overlay: {
    bg: 'utility.500',
    _dark: {
      bg: 'blackAlpha.500',
    },
  },
  footer: {
    borderTopWidth: '1px',
  },
  closeButton: {
    top: 3,
  },
});

const xsSize = definePartsStyle({
  header: {
    px: 4,
    pt: 3.5,
    pb: 2,
  },
  body: {
    px: 4,
    py: 2,
  },
  footer: {
    px: 4,
    py: 4,
  },
  closeButton: {
    top: 3,
    right: 3,
  },
});

export const drawerTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes: {
    xs: xsSize,
  },
});
